import React from "react";
import MenuItem from "../components/MenuItem";
import CenterLayout from "../components/CenterLayout";
import { Button } from "@mui/material";

const barItems = [
    {
        title: "Aperol Spritz",
        description: "NB! Kan ikke kjøpes for bong",
        price: 40,
    },
    {
        title: "Pausens Drink",
        description: "Varierer med barens pause-temaer. Ta sjansen og prøv da vel!",
        price: 40,
    },
    {
        title: "Shots!",
        description: "Valgfri shot fra barens utvalg",
        price: 20,
    },
];

export default function BarMenu() {
    return (
        <CenterLayout>
            <h1 style={{ textAlign: "center" }}>ROMPA BAR</h1>
            <Button
                variant="contained"
                sx={{ backgroundColor: "#f56c42", color: "white", borderRadius: 100, my: 2 }}
                onClick={() => window.open("https://qr.vipps.no/28/2/01/031/4798866017?v=1", "_blank")}
            >
                Vipps her
            </Button>
            <h3 style={{ marginBottom: 24 }}>... eller bruk drikkebong</h3>

            {barItems.map((item, index) => (
                <MenuItem
                    key={index}
                    title={item.title}
                    description={item.description}
                    price={item.price}
                    style={{ marginBottom: 16 }}
                />
            ))}
        </CenterLayout>
    );
}
